import React from 'react';
import PropTypes from 'prop-types';
import './SectionHeader.scss';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const SectionHeader = ({ titles }) => (
    <div className="sub-level-name-holder">
        {titles.map(title => (
            <h4 key={generateReactKey(title)} id="section-header-title">
                {title}
            </h4>
        ))}
    </div>
);

SectionHeader.defaultProps = {
    titles: [],
};

SectionHeader.propTypes = {
    titles: PropTypes.array,
};

export default SectionHeader;
